import React from 'react';
import { type TableRowMenuOption, TableRowOptionsMenu } from 'venn-ui-kit';
import { useHistory } from 'react-router-dom';
import { navigateToManageDataPage, type ObjectId } from 'venn-utils';
import type { LibrarySearchEntity } from 'venn-api';

export const PortfoliosActionsMenu = ({ item }: { item: LibrarySearchEntity }) => {
  const history = useHistory();

  const objectId: ObjectId = item.portfolioId
    ? { portfolioId: item.portfolioId }
    : { privatePortfolioId: item.privatePortfolioId };

  const options: TableRowMenuOption[] = item
    ? [
        {
          label: 'Manage Data',
          onClick: () => navigateToManageDataPage(history, objectId, 'Portfolios', false),
        },
      ]
    : [];

  return (
    <span data-testid="actions-menu">
      <TableRowOptionsMenu
        usePortal
        // Need to adjust offset if adding/removing different menu options
        portalProps={{
          rightOffset: 75,
        }}
        options={options}
        menuClassName="actions-menu-dropdown"
      />
    </span>
  );
};
